import { RestaurantNavItem } from "./RestaurantNavItem";

export default RestaurantNavItem;
